__turbopack_context__.v({
  "show-number": "index-module-scss-module__NRZuKq__show-number",
});
